
import * as actions from './authType';

export const loginRequest = (
  username: string,
  password: string,
  propCode: string
): actions.LoginRequestAction => ({
  type: actions.LOGIN_REQUEST,
  payload: { username, password, propCode },
});

export const loginSuccess = (
  user: actions.User,
  token: string,
  propCode: string
): actions.LoginSuccessAction => ({
  type: actions.LOGIN_SUCCESS,
  payload: { user, token, propCode },
});

export const loginFailure = (error: string): actions.LoginFailureAction => ({
  type: actions.LOGIN_FAILURE,
  payload: error,
});

export const logout = (): actions.LogoutAction => ({
  type: actions.LOGOUT,
});
